import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  return (
    <AnimatePresence>
      {showConsent && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 bg-white shadow-lg z-50 border-t border-gray-200 px-4 sm:px-0"
        >
          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-gray-700 text-sm sm:text-base text-center sm:text-left">
                <p>
                  We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.{' '}
                  <a href="/privacy-policy" className="text-golf-orange hover:text-golf-green underline">
                    Learn more
                  </a>
                </p>
              </div>
              <div className="flex gap-4 w-full sm:w-auto">
                <button
                  onClick={handleDecline}
                  className="px-6 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors w-1/2 sm:w-auto"
                >
                  Decline
                </button>
                <button
                  onClick={handleAccept}
                  className="modern-button px-6 py-2 text-sm font-medium text-white w-1/2 sm:w-auto"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default CookieConsent;